var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8197 0H4.95988C3.63879 0 2.38723 0.538298 1.46015 1.47447C0.533072 2.41064 0 3.67447 0 5.00851V16.9915C0 18.3255 0.533072 19.5894 1.46015 20.5255C2.38723 21.4617 3.63879 22 4.95988 22H18.8197C20.1408 22 21.3924 21.4617 22.3195 20.5255C23.2466 19.5894 23.7796 18.3255 23.7796 16.9915V5.00851C23.7796 3.67447 23.2466 2.41064 22.3195 1.47447C21.3924 0.538298 20.1408 0 18.8197 0ZM4.95988 2.01277H18.8197C19.4223 2.01277 20.0018 2.2 20.4885 2.52766C20.9752 2.85532 21.3692 3.34681 21.5778 3.88511L13.9989 11.5383C13.4427 12.1 12.6778 12.4043 11.8898 12.4043C11.1018 12.4043 10.337 12.1 9.78071 11.5383L2.20182 3.88511C2.41041 3.3234 2.80442 2.85532 3.29114 2.52766C3.77786 2.2 4.35728 2.01277 4.95988 2.01277ZM18.8197 20.0106H4.95988C4.17186 20.0106 3.40702 19.7064 2.85077 19.1213C2.29453 18.5596 1.97005 17.7872 1.97005 16.9915V6.50638L8.36691 12.966C9.29399 13.9021 10.5455 14.417 11.8666 14.417C13.1877 14.417 14.4393 13.9021 15.3664 12.966L21.7632 6.50638V16.9915C21.7632 17.7872 21.4619 18.5596 20.8825 19.1213C20.3726 19.683 19.6078 20.0106 18.8197 20.0106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEnvelop);
export default __webpack_public_path__ + "static/media/ShareEnvelop.2a7b6963928538ec0220d7e768a35f25.svg";
export { ForwardRef as ReactComponent };